var parent = require('../../es/instance/bind');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/stable/instance/bind.js
// module id = 1108
// module chunks = 0